import React, { useEffect } from "react"
import { BsArrowUpShort } from "react-icons/bs"

const ScrollToTop = () => {
  useEffect(() => {
    function scrollUp() {
      const scrollup = document.getElementById("scroll-up")
      // When the scroll is higher than 560 viewport height, add the show-scroll class to the a tag with the scroll-top class
      if (this.scrollY >= 560) {
        scrollup.classList.add("show-scroll")
      } else {
        scrollup.classList.remove("show-scroll")
      }
    }
    window.addEventListener("scroll", scrollUp)

    const root = document.querySelector(":root")
    root.style.setProperty("--scroll-behavior", "smooth")

    return () => {
      root.style.setProperty("--scroll-behavior", "auto")
    }
  })

  return (
    <main className="main">
      <a href="#top" className="scrollup noSelect" id="scroll-up">
        <BsArrowUpShort className="scrollup__icon" />
      </a>
    </main>
  )
}

export default ScrollToTop
